import {  
  loadUnitEnumDataInProgress,
  loadUnitEnumDataSuccess,
  loadUnitEnumDataFailure,
  unitEnumOperationCompleted,
  loadUnitAndEnumSingleData,
} from "../state/unitsandenums/actions";
import swal from 'sweetalert';
import configData from "../config.json";
import { errorSweetAlert, fileSchemaSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
const serverBasePath=configData.SERVER_API_URL;


export const loadUnitsEnumsList = (page=0,pageSize=10) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadUnitEnumDataInProgress());
    const response = await fetch(serverBasePath+"/units/getUnitsEnumsList?page="+page+"&pageSize="+pageSize,
    {
      method: "GET", 
      headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    } 
    dispatch(loadUnitEnumDataSuccess(result));
  } catch (e) {
    dispatch(loadUnitEnumDataFailure());
    errorSweetAlert(e); 
  }
};

export const addNewUnitsEnumsFile = (data) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  dispatch(loadUnitEnumDataInProgress());
  try {
      const response = await fetch(serverBasePath+"/units/addNewUnitsEnumsFile", 
      {
        method: "POST",  
        headers: {
          Authorization: 'Bearer ' + token,       
          'type': 'formData',
        },
        body:data
      });
      dispatch(unitEnumOperationCompleted());
      const result = await response.json();
      if(response.status === 500 && result?.errors){
          fileSchemaSweetAlert(result);
          return;
      }
      if(response.status !== 200){
          oopsSweetAlert(result);
          return;
      }
      //dispatch(closeUnitsAndEnumsDialog());
      swal({
          title: "Success",
          text: result.message,
          icon: "success",
          closeOnClickOutside:false,
          closeOnEsc: false,
          allowOutsideClick: false,
      }).then(marked => {
        if (marked) {
          dispatch(loadUnitsEnumsList(''));
        }
      });
  } catch (e) {
      dispatch(loadUnitEnumDataFailure());
      errorSweetAlert(e);
  }
};


export const deleteUnitsAndEmums = (id) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadUnitEnumDataInProgress());
          const response = await fetch(serverBasePath+"/units/delete/"+id,
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(unitEnumOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadUnitsEnumsList(''));
              }
          });
      } catch (e) {   
          dispatch(loadUnitEnumDataFailure());
          errorSweetAlert(e); 
      }
  };
};


export const setLatestUnitsAndEmums = (rowId) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadUnitEnumDataInProgress());
          const response = await fetch(serverBasePath+"/units/"+rowId+"/setlatest",
          {
            method: "PUT",
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            }
          });
          dispatch(unitEnumOperationCompleted()); 
          const result = await response.json();
          if(response.status !==  200){
              oopsSweetAlert(result);
              return;
          }
          swal({
              title: "Success",
              text: result.message,
              icon: "success",
              closeOnClickOutside:false,
              closeOnEsc: false,
              allowOutsideClick: false,
          })
          .then(marked => {
              if (marked) {
                dispatch(loadUnitsEnumsList(''));
              }
          });
      } catch (e) {   
          dispatch(loadUnitEnumDataFailure());
          errorSweetAlert(e); 
      }
  };
};



export const loadUnitAndEnumEditData = (rowId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token'); 
    try {
        dispatch(loadUnitEnumDataInProgress());
        const response = await fetch(serverBasePath+"/units/getUnitEnumContent/"+rowId,
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        dispatch(unitEnumOperationCompleted()); 
        const data = await response.json();
        if(response.status !== 200){
            swal({
              title: 'Oops!',
              text: "There is some error while fetching the data. Please try again.",
              icon: "error",
              dangerMode: true,
          });
            return;
        }
        dispatch(loadUnitAndEnumSingleData(data));   
    } catch (e) {
        dispatch(loadUnitEnumDataFailure());   
        errorSweetAlert(e);
    }
};


export const downloadUnitFile = (rowId,fileName) =>  {
    return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
        try {
            dispatch(loadUnitEnumDataInProgress());
            const response = await fetch(serverBasePath+"/units/"+rowId+"/download",
            {
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status !== 200){
                dispatch(unitEnumOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',`${fileName}.json`); 
            document.body.appendChild(link);
            link.click();
            dispatch(unitEnumOperationCompleted()); 
        } catch (e) {   
            dispatch(loadUnitEnumDataFailure());
            errorSweetAlert(e);  
        }
    };
};